import { useEffect, useState } from "react";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useProduct } from "../../context/product/ProductContext";
import LinkButton from "../buttons/button/LinkButton";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { getEarlyAccessToSaleContext } from "../../utils/loyalty/getEarlyAccessToSaleContext";
import { generateOneLinkURL } from "../../utils/oneLinkGenerator";
import styles from "./EarlyAccessToSaleBox.scss";
import { formatDateForLoyalty } from "../../../common/releaseDateBanner/formatDateForLoyalty";

const EarlyAccessToSaleBox = () => {
  const { getTranslation, isMobile, webContext } = useRuntimeConstants();
  const { product } = useProduct();
  const [earlyAccessToSaleContext, setEarlyAccessSaleContext] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (!product) return;

    const fetchEarlyAccessToSaleContext = async () => {
      const { isEarlyAccessToSale, earlyAccessToSaleContext, endDate } =
        await getEarlyAccessToSaleContext(product);

      if (isEarlyAccessToSale) {
        setEarlyAccessSaleContext(earlyAccessToSaleContext);
        setEndDate(endDate);
      } else {
        setEarlyAccessSaleContext(null);
        setEndDate(null);
      }
    };

    fetchEarlyAccessToSaleContext();
  }, [product]);

  if (!product || !earlyAccessToSaleContext) {
    return null;
  }

  const buttonText = getTranslation("download_the_app_cta_title");
  const generatedUrl = generateOneLinkURL(webContext, product);

  return (
    <div className={styles.earlyAccessToSaleBox}>
      <div className={styles.header}>
        <span className={styles.earlyAccessLabel}>
          {getTranslation("early_access_label")}
        </span>
        <div className="product-asos-world" />
      </div>
      <p className={styles.price}>
        <span>{getTranslation("early_access_to_sale_price_on_app")}</span>
        <span>{` ${earlyAccessToSaleContext.current.text}`}</span>
        <span
          className={styles.discountPercentage}
        >{` (-${earlyAccessToSaleContext.discountPercentage}%)`}</span>
      </p>
      <p className={styles.description}>
        <span>
          {getTranslation("early_access_to_sale_app_adoption_description")}
        </span>
      </p>
      <p className={styles.date}>
        {getTranslation("early_access_until", {
          date: formatDateForLoyalty(endDate),
        })}
      </p>
      <LinkButton
        href={
          isMobile
            ? generatedUrl
            : `/discover/our-apps/?campaign=pdp-app-download&deepLink=asos://prd%3Fiid=${product.id}&media=button`
        }
        type={BUTTON_TYPES.loyaltyFullWidth}
        additionalClasses={styles.button}
        ariaLabel={buttonText}
      >
        <div className={styles.buttonText}>{buttonText}</div>
      </LinkButton>
    </div>
  );
};

export default EarlyAccessToSaleBox;
